// Background music: one looping <audio>, started on the first user gesture (browsers block autoplay),
// faded in/out by the screens that want it (lobby, Sit N Go waiting room). Setting "pfp_music" on|off
// is authoritative everywhere: off means silent on every screen.
const SRC = "/assets/sfx/bg_music.mp3";
// licence attribution (user-supplied wording) — shown in the lobby footer
export const MUSIC_CREDIT = "Music: 'What's Next' by Nick Petrov";
const DEFAULT_VOLUME = 0.18;
let el = null;
let wanted = false;
let fade = null;
let factor = 1; // per-screen loudness: lobby 1, table softer

// the player's ON/OFF switch wins on every screen — no exceptions
const enabled = () => localStorage.getItem("pfp_music") !== "off";
const level = () => { const v = parseFloat(localStorage.getItem("pfp_music_volume")); return (Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : DEFAULT_VOLUME) * factor; };
const TAIL_CUT_S = 3.0; // the track ends with ~3s of silence: loop back before it so the music never "stops then starts"
const audio = () => {
  if (!el) {
    el = new Audio(SRC); el.loop = false; el.preload = "auto"; el.volume = 0;
    el.addEventListener("timeupdate", () => { if (el.duration && el.currentTime >= el.duration - TAIL_CUT_S) { el.currentTime = 0; el.play().catch(() => {}); } });
    el.addEventListener("ended", () => { el.currentTime = 0; el.play().catch(() => {}); });
  }
  return el;
};
const ramp = (to, ms, then) => {
  clearInterval(fade);
  const a = audio(); const from = a.volume; const t0 = performance.now();
  fade = setInterval(() => {
    const k = Math.min(1, (performance.now() - t0) / ms);
    a.volume = from + (to - from) * k;
    if (k >= 1) { clearInterval(fade); then?.(); }
  }, 50);
};
const tryPlay = () => {
  if (!wanted || !enabled()) return;
  const a = audio();
  if (!a.paused) { ramp(level(), 800); return; }
  a.play().then(() => ramp(level(), 1500)).catch(() => {});
};
// a gesture anywhere lets the music start once the browser allows it
["pointerdown", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, tryPlay, { passive: true }));
window.addEventListener("pfp-setting", (e) => {
  if (e.detail.key === "pfp_music") (e.detail.value === "off" ? fadeOut() : tryPlay());
  if (e.detail.key === "pfp_music_volume" && el && !el.paused) { clearInterval(fade); el.volume = level(); }
});
const fadeOut = () => { if (el && !el.paused) ramp(0, 800, () => { if (!wanted || !enabled()) el.pause(); }); };
// a change of screen volume while already playing (e.g. waiting room → game) is applied straight away
const applyLevel = () => { if (el && !el.paused && enabled()) { clearInterval(fade); el.volume = level(); } };

export const music = {
  volume: level,
  start(screenFactor = 1, opts = {}) {
    if (opts.ifIdle && wanted) return; // the app shell's splash call: never override a screen (e.g. a table after a reload) that already set its own level/rule
    wanted = true; factor = screenFactor;
    if (enabled()) { tryPlay(); applyLevel(); } else fadeOut();
  },
  stop() { wanted = false; fadeOut(); },
};
